export default [
  {
    title: 'breadcrumb.bank',
    route: 'list-bank',
    icon: '',
    resource: 'bank-setting',
    action: 'read',
  },
]
